<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import CookieReset from './../components/CookieReset.vue';

const store = useStore();
const route = useRoute();
const content = computed(() => store.getters['contentpage/get']);

const isDataPolicyPage = computed(() => route.path.includes('datenschutz'));
</script>

<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div :id="content?.title?.de" class="min-h-app contentpageContent">
            <Notification v-if="content?.published_at === null" class="bg-red text-white border-b border-gray-300">
                <p>
                    {{ $t('Content is not yet published and is displayed because you are logged in as administrator.') }}
                </p>
            </Notification>
            <div class="min-h-[65vh] max-w-[100vw]">
                <div class="shadow-md py-8">
                    <div class="container mx-auto">
                        <h1>
                            {{ $translate(content?.title) }}
                        </h1>
                    </div>
                </div>

                <div class="container mx-auto mt-8 content" v-html="$translate(content?.content)"></div>

                <div v-if="isDataPolicyPage" class="container mx-auto py-9">
                    <CookieReset />
                </div>
            </div>
        </div>
    </transition>
</template>

<style>
.contentpageContent {
    word-break: break-word;
}
</style>
